import * as Font from 'expo-font';
import { textsDict } from './ImagesManagementUtils';
import { getValue } from '../defaultConfigurations/UtilsConfigurations';
import { kbd_success_icon } from './DictionaryManagementUtils';

export function LocStr(src, lang) {
  // if (lang==='english') return src+'$';

  if (textsDict !== null) {
    const rec = textsDict[src];
    if (rec !== null && rec !== undefined && rec.length > 0) {
      const item = rec[0];
      if (item !== null && item !== undefined) {
        const res = item[lang];
        if (res !== null && res !== undefined) {
          return res;
        }
      }
    }
  }
  return src;
}

export const cleanJsonToPublish = (mainConfig) => {
  const newConfig = JSON.parse(JSON.stringify(mainConfig));
  const { configurations } = newConfig;
  removeFileUri64(configurations);

  delete newConfig.screens;
  return newConfig;
};

export const removeFileUri64 = ({
  theme, launch, onboarding, general, services,
}) => {
  theme.fonts.custom_font.fUri = null;
  theme.fonts.custom_bold_font.fUri = null;

  launch.keyboard.no_results_image.fUri = null;
  launch.keyboard.bank_logo.fUri = null;
  services.menu.keyboard_logo.fUri = null;
  services.menu.keyboard_disabled_logo.fUri = null;

  launch.error_messages.general_error_icon.fUri = null;
  launch.error_messages.no_connection_icon.fUri = null;
  launch.error_messages.transaction_failed_icon.fUri = null;
  launch.error_messages.permission_to_photos_icon.fUri = null;
  launch.error_messages.no_landscape_icon.fUri = null;

  launch.empty_state.empty_state_icon.fUri = null;

  onboarding.announcement.kbd_announcement_icon.fUri = null;
  onboarding.promotion.menu_screenshot.fUri = null;
  onboarding.promotion.onboarding_big_stickers.fUri = null;
  onboarding.promotion.onboarding_small_stickers.fUri = null;
  onboarding.instructions.kbd_come_back_icon.fUri = null;
  onboarding.instructions.kbd_success_icon.fUri = null;

  general.success_image.fUri = null;
  general.verify_recipient_icon.fUri = null;
  general.img_arrow_right_button.fUri = null;

  services.menu.bank_logo.fUri = null;
  services.menu.iMsg_bank_logo.fUri = null;
  services.menu.hotkey_qab.fUri = null;

  services.screens_ordering.forEach((serviceKey) => {
    services[serviceKey].icon.fUri = null;
    services[serviceKey].icon_action_bar.fUri = null;
  });
};

export const getDateFormat = () => {
  const date = new Date();
  return date.toUTCString(); // Example: Mon, 10 Jan 2022 06:33:49 GMT
};

export const convertDateFormat = (universalDate) => {
  const localDate = new Date(universalDate); // Wed Jan 12 2022 08:55:47 GMT+0200 (Israel Standard Time)
  const convertedDate = `${localDate}`.slice(4, 21); // Jan 12 2022 08:55
  return convertedDate;
};

export const getUserVersion = ({ firebase_version, web_tool_version }) => {
  const firebaseStr = firebase_version < 100 ? `00${firebase_version}`.slice(-3) : firebase_version;
  const last_web_tool_version = web_tool_version.substring(web_tool_version.indexOf('.') + 1);

  return `${last_web_tool_version}.${firebaseStr}`;
};

export function calcInitials(name) {
  const fullName = name.split(' ');
  let initials;
  if (fullName.length > 1) {
    initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
  } else {
    initials = fullName.shift().charAt(0);
  }
  return initials.toUpperCase();
}

export function xlateText(src = '', theJSON = null) {
  let res = src
    .replace('[amount]', '100 円')
    .replace('[name]', 'John Smith')
    .replace('[time of day]', 'afternoon')
    .replace('[first name]', 'Alex')
    .replaceAll('[BR]', '\n');

  if (theJSON !== null) {
    const { bank_name } = theJSON.configurations.general;
    res = res
      .replace('[bank]', bank_name)
      .replace('[Bank]', bank_name)
      .replace('[bank name]', bank_name)
      .replace('[Bank name]', bank_name)
      .replace('[Bank Name]', bank_name)
      .replace('[kbd]', bank_name);
  }

  return res;
}

export const getDispText = (theKey, globJSON) => getValue(globJSON, theKey);

export function getRef(slideshowRefs) {
  if (slideshowRefs === null) return null;
  const { index } = slideshowRefs;
  const newRef = slideshowRefs.arr[index];
  slideshowRefs.index = index + 1;
  return newRef;
}

//= ====================================================================

function configuredToUseCustomFonts(
  globJSON,
  platform = '',
  isOnboarding = false,
) {
  const { fonts } = globJSON.configurations.theme;
  if (isOnboarding) {
    return !fonts.use_custom_font_in_onboarding_screens;
  }
  // in keyboard - only Android
  if (platform === 'iOS') {
    return false;
  }
  return !fonts.use_custom_android_font_in_keyboard;
}

export function getRegularFont(globJSON, platform = '', isOnboarding = false) {
  const { fonts } = globJSON.configurations.theme;

  if (configuredToUseCustomFonts(globJSON, platform, isOnboarding)) {
    if (
      fonts.custom_font.fUri !== null
            && fonts.custom_font.fUri.length > 0
    ) {
      const indexType = fonts.custom_font.fName.lastIndexOf('.');
      if (indexType !== -1) {
        return fonts.custom_font.fName.substring(0, indexType);
      }
    }
  }
  if (platform === 'iOS') {
    return 'SF-Regular';
  }
  return 'Rubik-Regular';
}

export function getMediumFont(globJSON, platform = '', isOnboarding = false) {
  const { fonts } = globJSON.configurations.theme;
  if (configuredToUseCustomFonts(globJSON, platform, isOnboarding)) {
    if (
      fonts.custom_bold_font.fUri !== null
            && fonts.custom_bold_font.fUri.length > 0
    ) {
      const indexType = fonts.custom_bold_font.fName.lastIndexOf('.');
      if (indexType !== -1) {
        return fonts.custom_bold_font.fName.substring(0, indexType);
      }
    }
  }
  if (platform === 'iOS') {
    return 'SF-Medium';
  }
  return 'Rubik-Medium';
}

export function getBoldFont(globJSON, platform = '', isOnboarding = false) {
  const { fonts } = globJSON.configurations.theme;
  if (configuredToUseCustomFonts(globJSON, platform, isOnboarding)) {
    if (
      fonts.custom_bold_font.fUri !== null
            && fonts.custom_bold_font.fUri.length > 0
    ) {
      const indexType = fonts.custom_bold_font.fName.lastIndexOf('.');
      if (indexType !== -1) {
        return fonts.custom_bold_font.fName.substring(0, indexType);
      }
    }
  }
  if (platform === 'iOS') {
    return 'SF-Bold';
  }
  return 'Rubik-Bold';
}

export async function loadWebFonts(globJSON) {
  const theFonts = {};
  const { fonts } = globJSON.configurations.theme;

  if (
    fonts.custom_font.fUri !== null
        && fonts.custom_font.fUri.length > 0
  ) {
    const indexType = fonts.custom_font.fName.lastIndexOf('.');
    if (indexType !== -1) {
      const name = fonts.custom_font.fName.substring(0, indexType);
      theFonts[name] = {
        uri: fonts.custom_font.fUri,
        fontDisplay: Font.FontDisplay.FALLBACK,
      };
    }
  }
  if (
    fonts.custom_bold_font.fUri !== null
        && fonts.custom_bold_font.fUri.length > 0
  ) {
    const indexType = fonts.custom_bold_font.fName.lastIndexOf('.');
    if (indexType !== -1) {
      const name = fonts.custom_bold_font.fName.substring(
        0,
        indexType,
      );
      theFonts[name] = {
        uri: fonts.custom_bold_font.fUri,
        fontDisplay: Font.FontDisplay.FALLBACK,
      };
    }
  }

  if (Object.keys(theFonts).length > 0) {
    try {
      await Font.loadAsync(theFonts);
    } catch (errMsg) {
      console.log(errMsg);
    }
  }
}
